import Vue from "vue";
import VueCookies from "vue-cookies";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import InfiniteSlideBar from "vue-infinite-slide-bar";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/validate";
import { i18n } from "./plugins/i18n";
import store from "./store";
import { router } from "./router";
import * as moment from "moment";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("InfiniteSlideBar", InfiniteSlideBar);

Vue.use(VueCookies);
moment.locale(i18n.locale);
Vue.filter(
  "formatDate",
  (value) => `${moment(value).format("dddd")}, ${moment(value).format("LL")}`
);
Vue.filter("formatTime", (value) => moment(value, "HH:mm").format("HH:mm"));

Vue.config.productionTip = false;

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
